import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useRole, type Role } from './useRole';

export interface RoleGuardProps {
  allow: Role | Role[];
  children: ReactNode;
  /** Rendered when no role matches. Defaults to redirect to /not-authorized. */
  fallback?: ReactNode;
}

export function RoleGuard({ allow, children, fallback }: RoleGuardProps) {
  const { ready, roles, isPlatformAdmin } = useRole();
  if (!ready) return <div className="vp-root" style={{ padding: 24 }}>Caricamento profilo…</div>;

  const list = Array.isArray(allow) ? allow : [allow];

  // platform-admin always passes through (existing behaviour).
  if (isPlatformAdmin || list.some((r) => roles.includes(r))) {
    return <>{children}</>;
  }

  if (fallback !== undefined) return <>{fallback}</>;
  return <Navigate to="/not-authorized" replace />;
}
